<template>
    <div class="grey lighten-3 pa-4 greyContainer">
        <spieler-export-filter v-if="user.permissions.pass || user.permissions.passRead ||
                                     user.permissions.classic || user.permissions.bowling"
                               level="pass"/><!-- vereins-id="11101"-->
        <v-alert v-else text color="error" icon="mdi-information">
            Du hast leider keine Berechtigung für diesen Bereich!
        </v-alert>
    </div>
</template>

<script>
import SpielerExportFilter from "@/views/spielerExport/spielerExportFilter";
export default {
    name: "spielerExport",
    components: {SpielerExportFilter},
    computed: {
        user(){ return this.$store.state.user }
    },
}
</script>

<style scoped>
    .greyContainer{position: fixed; top: 48px; bottom: 0; left: 0; right: 0; overflow-y: scroll}
</style>